import { mapRImage, mapRImages } from '@dh/api/helpers';
import { CreateInstitutionForm } from '@dh/screens/signup/types';
import { removeEmptyValues } from '@dh/utils';
import {
    Institution,
    InstitutionType,
    mapBudget,
    mapLanguageCodes,
    mapPrinciples,
    mapSoftware,
    mapTopicKnowledges,
    mapUsers,
    RCreateInstitutionBody,
    RInstitution
} from '@dh/types';

export const mapInstitution = (institution: RInstitution): Institution => ({
    id: institution.id,
    documentId: institution.documentId,
    type: institution.type as InstitutionType,
    name: institution.name,
    email: institution.email ?? undefined,
    phone: institution.phone ?? undefined,
    info: { title: institution.infoTitle ?? undefined, text: institution.info ?? undefined },
    slogan: institution.slogan ?? undefined,
    website: institution.website ?? undefined,
    logo: mapRImage(institution.logo),
    media: mapRImages(institution.media),
    admins: mapUsers(institution.admins),
    members: mapUsers(institution.members),
    address: {
        fullAddress: institution.fullAddress,
        coordinates: [institution.addressLongitude, institution.addressLatitude]
    },
    isPublic: institution.type === 'company' ? !!institution.isPublic : undefined,
    used_software:
        institution.type === 'company' ? mapSoftware(institution.used_software ?? []) : undefined,
    topicsKnowledge:
        institution.type === 'company'
            ? mapTopicKnowledges(institution.topicsKnowledge)
            : undefined,
    principles: institution.type === 'company' ? mapPrinciples(institution.principles) : undefined,
    budget:
        institution.type === 'company' && !!institution.budget
            ? mapBudget(institution.budget)
            : undefined,
    languages: mapLanguageCodes(institution.languages)
});

export const mapInstitutions = (institutions: RInstitution[]): Institution[] =>
    removeEmptyValues(institutions.map(mapInstitution));

export const mapCreateInstitutionFormToBody = (
    form: CreateInstitutionForm,
    type: InstitutionType
): RCreateInstitutionBody => {
    const name = form.name.value;
    const address = form.address.value;
    const website = form.website.value;

    if (name === undefined || address === undefined) {
        throw new Error('Mandatory values are missing in the data you tried to submit!');
    }

    return {
        type,
        name,
        website: website ?? null,
        fullAddress: address.fullAddress,
        addressLatitude: address.coordinates[1],
        addressLongitude: address.coordinates[0]
    };
};
